import { z } from "zod";

const basicUserInformationSchema = z.object({
  firstName: z.string().min(1, { message: "First name is required" }),
  lastName: z.string().min(1, { message: "Last name is required" }),
  email: z.string().email({ message: "Email is required" }),
  timeZone: z.string().nullable(),
});
type BasicUserInformationFormData = z.infer<typeof basicUserInformationSchema>;

export { basicUserInformationSchema };
export type { BasicUserInformationFormData };
